import { createAsyncThunk } from '@reduxjs/toolkit';
import { quizApi } from '~/apis/quiz';
import {
  ANSWER_FILE_QUESTION,
  ANSWER_QUESTION,
  COMPLETE_QUIZ,
  GET_DETAIL_QUIZ,
  START_QUIZ,
} from '~/utils/constants/actionType';
import { IBodyAnswerQuestion, IBodyCompleteQuiz, IBodyStartQuiz, IQueryGetQuizDetail } from '~/utils/interface/quiz';

export const getDetailQuiz = createAsyncThunk(
  GET_DETAIL_QUIZ,
  async (query: IQueryGetQuizDetail, { rejectWithValue }) => {
    try {
      const res = await quizApi.getDetailQuiz(query);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const startQuiz = createAsyncThunk(START_QUIZ, async (payload: IBodyStartQuiz, { rejectWithValue }) => {
  try {
    const res = await quizApi.startQuiz(payload);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const answerQuestion = createAsyncThunk(
  ANSWER_QUESTION,
  async (payload: IBodyAnswerQuestion, { rejectWithValue }) => {
    try {
      const res = await quizApi.answerQuestion(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const answerFileQuestion = createAsyncThunk(
  ANSWER_FILE_QUESTION,
  async (payload: FormData, { rejectWithValue }) => {
    try {
      const res = await quizApi.answerFileQuestion(payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const completeQuiz = createAsyncThunk(COMPLETE_QUIZ, async (payload: IBodyCompleteQuiz, { rejectWithValue }) => {
  try {
    const res = await quizApi.completeQuiz(payload);
    return res.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
